import { addPost, editPost } from './request';
export default {
  data() {
    return {
      dialogVisible: false,
      dataFrom: {
        isEdit: undefined
      },
      isShow: false
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('岗位名称')
        }],
        sort: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('排序')
        }]
      };
    }
  },
  methods: {
    init(data, type, customerId) {
      this.isShow = type || false;
      if (data.companyPostId) {
        this.dataFrom = {
          name: data.name,
          sort: data.sort,
          companyPostId: data.companyPostId
        };
      }
      if (type) {
        this.dataFrom.isEdit = 1;
      }
      if (customerId) {
        this.dataFrom.customerId = customerId;
      }
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          let fun = this.dataFrom.companyPostId ? editPost : addPost;
          fun(this.dataFrom).then(res => {
            this.$message.success(this.$t('操作成功'));
            this.$emit('ok', res);
            this.$emit('cancel');
          });
        }
      });
    }
  }
};